<template>
  <form
    ref="form"
    novalidate
    class="container px-0 d-flex flex-column justify-content-between needs-validation"
    @submit="submit"
  >
    <div class="flex-grow-1">
      <div class="row">
        <BootstrapFormControl
          v-model="modelName"
          name="Component Name"
          class="col-8"
          required
          :error="errorMessages.get('name')"
          :server-error="serverError"
        />
      </div>
      <div class="row">
        <BootstrapFormControl
          v-model="modelDescription"
          name="Component Description"
          class="col"
          required
          :error="errorMessages.get('description')"
          :server-error="serverError"
          textarea
        />
      </div>
      <div class="row">
        <BootstrapFormControl
          v-model="modelCostUnitCalcMethod"
          name="Cost Unit Calculation Method"
          class="col"
          required
          :error="errorMessages.get('cost_unit_calc_method')"
          :server-error="serverError"
          textarea
        />
      </div>
      <div class="row mt-3">
        <div class="d-flex w-100">
          <BootstrapButton
            name="submit"
            class="me-2"
            type="submit"
            :disabled="loading"
            :loading="loading"
            @click.stop
          >
            Save
          </BootstrapButton>
          <BootstrapButton name="cancel" variant="secondary" @click="router.go(-1)">
            Cancel
          </BootstrapButton>
        </div>
      </div>
    </div>
  </form>
</template>
<script lang="ts" setup>
const props = defineProps<{
  costUnitCalcMethod: string;
  description: string;
  errorMessages: Map<any, any>;
  loading: boolean;
  name: string;
  serverError: boolean;
}>();

const emit = defineEmits<{
  'update:costUnitCalcMethod': [value: string];
  'update:description': [value: string];
  'update:name': [value: string];
  submit: [form: globalThis.Ref<HTMLFormElement | null>];
}>();

const router = useRouter();

// Template ref
const form = ref<HTMLFormElement | null>(null);

// Models
const modelCostUnitCalcMethod = computed({
  get: () => props.costUnitCalcMethod,
  set: (value) => emit('update:costUnitCalcMethod', value),
});
const modelDescription = computed({
  get: () => props.description,
  set: (value) => emit('update:description', value),
});
const modelName = computed({
  get: () => props.name,
  set: (value) => emit('update:name', value),
});

// https://getbootstrap.com/docs/4.6/components/forms/?#how-it-works
const submit = async (event: Event) => {
  if (form.value?.checkValidity() === false) {
    event.preventDefault();
    event.stopPropagation();
    form.value.classList.add('was-validated');
  } else {
    event.preventDefault();
    emit('submit', form);
  }
};
</script>
